// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3d084245","455":"a9d90039","977":"cf283520"}[chunkId] + ".chunk.js";
};